import { accountCommands } from '~/components/command-menu/commands/account'
import { adminCommands } from '~/components/command-menu/commands/admin'
import { createCommands } from '~/components/command-menu/commands/create'
import { helpCommands } from '~/components/command-menu/commands/help'
import { inviteCommands } from '~/components/command-menu/commands/invite'
import { navigationCommands } from '~/components/command-menu/commands/navigation'
import { settingsCommands } from '~/components/command-menu/commands/settings'
import { CommandProps } from '~/components/command-menu/types'

export const commands: CommandProps[] = [
  ...accountCommands,
  ...navigationCommands,
  ...createCommands,
  ...inviteCommands,
  ...helpCommands,
  ...settingsCommands,
  ...adminCommands,
]
